class SideCart extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.cartObject = null;
    this.sideCartTriggers = document.querySelectorAll(
      "[data-sidecart-trigger]"
    );
    this.sideCartClose = this.querySelector("[data-sidecart-close]");
    this.sideCartWrapper = this.querySelector("[data-sidecart-wrapper]");
    this.sideCartOverlay = this.querySelector("[data-sidecart-overlay]");
    this.cartModal = document.querySelector("cart-modal");
    this.cartGiftMessage = this.querySelector('cart-gift-message')
    this.sideCartTriggers?.forEach((trigger) =>
      trigger.addEventListener("click", () =>
        this.sideCartWrapper.classList.contains("menu-active")
          ? this.close()
          : this.open()
      )
    );
    this.sideCartClose?.addEventListener("click", this.close.bind(this));
    this.sideCartOverlay?.addEventListener("click", this.close.bind(this));

    this.getCart();
  }

  async open() {
    await this.getCart();
    this.sideCartWrapper.classList.add("menu-active");
    document.querySelector("body").classList.add("sidecart-open");
    this.updateDropShadow();
  }

  close() {
    this.sideCartWrapper.classList.remove("menu-active");
    document.querySelector("body").classList.remove("sidecart-open");
  }

  async getCart() {
    try {
      const res = await fetch("/cart.js");
      const data = await res.json();
      if (data) {
        this.cartObject = data;
        if(this.cartGiftMessage) this.cartGiftMessage.getGiftMessage(data);
      }
    } catch (error) {}
  }

  updateDropShadow() {
    if (document.getElementById("sidecartItems")) {
      let contentsElement = document.getElementById("sidecartItems");
      let scroll = contentsElement.scrollHeight;
      let offset = contentsElement.offsetHeight;
      document
        .querySelector(".sidecart__footer")
        ?.classList.toggle("footer-dropshadow-enabled", scroll > offset);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(parsedState) {
    if (parsedState && parsedState?.items) this.cartObject = parsedState;
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);
      if (elementToReplace) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section?.section],
          section.selector
        );
      }
    });
    document
      .querySelector(".sidecart__contents")
      ?.classList.toggle("is-empty", parsedState.item_count === 0);

    if (this.cartModal) {
      const mouseoverEvent = new Event("mouseenter");
      document
        .querySelector(".desktop-header-cart-container .cart-modal-wrapper")
        .dispatchEvent(mouseoverEvent);
    } else {
      this.open();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "sidecartContents",
        section: "sidecart",
        selector: ".sidecart__contents",
      },
      {
        id: "sidecartContents",
        section: "sidecart",
        selector: ".sidecart__table",
      },
      {
        id: "sidecartContents",
        section: "sidecart",
        selector: ".sidecart__table",
      },
      {
        id: "cartModal",
        section: "header-navigation",
        selector: ".cart-modal",
      },
      {
        id: "cartShippingPromo",
        section: "sidecart",
        selector: ".sidecart__shipping-promo",
      },
      {
        id: "sidecart__header-total-badge",
        section: "sidecart",
        selector: "#sidecart__header-total-badge",
      },
      {
        id: "cart-live-region-text",
        section: "sidecart",
        selector: "#cart-live-region-text",
      },
      {
        id: "mobileIconsContainer",
        section: "header-navigation",
        selector: "#navbar__cart__count",
      },
      {
        id: "desktopIconsContainer",
        section: "header-navigation",
        selector: "#navbar__cart__count",
      },
      {
        id: 'cart-section',
        section: 'cart',
        selector: '.cart__wrapper'
      },
      {
        id: 'cart-section',
        section: 'cart',
        selector: '.cart__container-mobile'
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    try {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    } catch {
      return "";
    }
  }
}

customElements.define("side-cart", SideCart);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );
    this.sidecart = document.querySelector("side-cart");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.querySelectorAll("[data-remove-item]")?.forEach((el) =>
      el?.addEventListener("click", this.removeItem.bind(this))
    );
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.dataset.key,
      parseInt(event.target.value),
      document.activeElement.getAttribute("name")
    );
  }

  removeItem(event) { 
    this.updateQuantity(
      event.target.dataset.index,
      event.target.dataset.key,
      0,
      document.activeElement.getAttribute("name")
    );
  }

  async addGiftToCart() {
    try {
      fetch("/cart.js")
        .then((response) => {
          return response.json();
        })
        .then(async (data) => {
          let formData;
          let applicableGif = false;

          if (window.gift_by === "cart_amount") {
            if (data.total_price >= Number(window.gift_price * 100)) {
              applicableGif = true;
            }
          } else if (window.gift_by === "adding_product_with_tags") {
            const productTags = await Promise.all(
              data.items.map(async (el) => {
                let productInfo = await fetch(`/products/${el.handle}.js`);
                productInfo = await productInfo.json();
                return productInfo.tags;
              })
            );

            const applicableTags = window.gift_tags.split(",");
            productTags.forEach((pt) => {
              if (applicableGif) return;
              applicableTags.forEach((at) => {
                if (pt.includes(at)) {
                  applicableGif = true;
                  return;
                }
              });
            });
          }

          if (!applicableGif) return;

          let isExist = false;

          data.items.forEach((value, index, array) => {
            if (value.id === +window.gift_variant_id) {
              isExist = true;
            }
          });

          if (isExist) {
            return;
          }

          formData = {
            items: [
              {
                id: parseInt(window.gift_variant_id),
                quantity: 1,
              },
            ],
            sections: this.sidecart
              ?.getSectionsToRender()
              .map((section) => section.id)
              .join(),
          };

          fetch(`${routes.cart_add_url}.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((response) => {
              this.sidecart?.renderContents(response);
              return response;
            })
            .catch((error) => {
              if (error) {
                const toast = document.querySelector("toast-alert");
                if (toast) {
                  toast.addMessage({
                    type: "error",
                    text: window.cartStrings.error || "Error updating cart",
                  });
                }
              }
            });
        });
    } catch (error) {
      const toast = document.querySelector("toast-alert");
      if (toast) {
        toast.addMessage({
          type: "error",
          text: window.cartStrings.error || "Error updating cart",
        });
      }
    }
  }

  
  async updateQuantity(line, key, quantity) {
    this.enableLoading(line);

    const sections = this.sidecart
      ?.getSectionsToRender()
      .map((section) => section.section);

    const lineItemQuantities = this.sidecart.cartObject.items?.map((item) =>
      item.key === key ? quantity : item.quantity
    );

    const body = JSON.stringify({
      updates: lineItemQuantities,
      sections: sections.filter(
        (item, index) => sections.indexOf(item) === index
      ),
      sections_url: window.location.pathname,
    });

    const routes = window.routes;

    try {
      const response = await fetch(`${routes.cart_update_url}.js`, {
        ...fetchConfig(),
        ...{ body },
      });
      const state = await response.json();

      if (state?.errors || state?.status === 422) {
        throw new Error(state?.errors || state?.description);
      } else {
        const cartBubble = document.querySelector(
          "#sidecart__header-total-badge .cart-bubble-quantity"
        );
        document
          .querySelector(".sidecart__contents")
          ?.classList.toggle("is-empty", state.item_count === 0);

        if (cartBubble) {
          cartBubble.toggleAttribute("hidden", state.item_count === 0);
          cartBubble.textContent = state.item_count;
        }

        if (window.gift_available && !window.gift_variant_id.trim() == "") {
          this.addGiftToCart();
        }
        this.sidecart?.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              ?.querySelector(section.selector) ||
            document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              state.sections[section?.section],
              section.selector
            );
          }
        });
        if (state?.items) this.sidecart.cartObject = state;

        this.updateLiveRegions(state.item_count);
        this.disableLoading();

        const cartUpdatedEvent = new CustomEvent("cartUpdated");
        document.dispatchEvent(cartUpdatedEvent);
      }
    } catch (error) {
      const toast = document.querySelector("toast-alert");

      if (toast) {
        toast.addMessage({
          type: "error",
          text: window?.cartStrings?.error || error || "There was an error while updating your cart",
        });
      }
    } finally {
      this.querySelectorAll(".loading-overlay").forEach((overlay) =>
        overlay?.classList.add("hidden")
      );
      this.disableLoading(line);
    }
  }

  updateLiveRegions(itemCount) {
    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    document
      .querySelector(`.sidecart__line-item[data-line="${line}"`)
      ?.classList.add("updating");
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    document
      .querySelector(`.sidecart__line-item[data-line="${line}"`)
      ?.classList.remove("updating");
  }
}

customElements.define("cart-items", CartItems);
class CartModal extends HTMLElement {
  constructor() {
    super();

    this.sidecart = document.querySelector("side-cart");
    this.trigger = document.querySelector(
      ".desktop-header-cart-container .cart-modal-wrapper"
    );
    this.trigger.addEventListener("mouseenter", this.openModal.bind(this));
    this.trigger.addEventListener("mouseleave", this.closeModal.bind(this));

    this.triggerClickHandler = this.triggerClickHandler.bind(this);
    this.cartUpdatedHandler = this.cartUpdatedHandler.bind(this);

    document.addEventListener("cartUpdated", this.cartUpdatedHandler);
  }

  addEventListenerToTrigger() {
    this.querySelectorAll("[data-sidecart-trigger]").forEach((el) =>
      el.addEventListener("click", this.triggerClickHandler)
    );
  }

  removeEventListenerFromTrigger() {
    this.querySelectorAll("[data-sidecart-trigger]").forEach((el) =>
      el.removeEventListener("click", this.triggerClickHandler)
    );
  }

  cartUpdatedHandler() {
    this.removeEventListenerFromTrigger();
    this.addEventListenerToTrigger();
  }

  triggerClickHandler(event) {
    event.preventDefault();
    this.sidecart.open();
  }

  openModal() {
    window.clearTimeout(this.timerId);
    this.style.display = "block";
  }
  closeModal() {
    this.timerId = window.setTimeout(() => {
      this.style.display = "none";
    }, 500);
  }
  connectedCallback() {
    this.addEventListenerToTrigger();
  }
  disconnectedCallback() {
    this.removeEventListenerFromTrigger();
  }
}

customElements.define("cart-modal", CartModal);